import { expVal } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

const resolvedPackages = new Map<string, boolean>();

export function isRelayEnabled(callerPackage?: string): boolean {
	if (process.env.BUILD_VARIANT === 'relay') return true;

	// No package specified — use global switch
	if (!callerPackage) {
		return expVal('confluence_apollo_to_relay_migration', 'isEnabled', false);
	}

	if (!resolvedPackages.has(callerPackage)) {
		if (expVal('confluence_apollo_to_relay_migration', 'isEnabled', false)) {
			// Experiment gates the per-package allow list
			const packages = StatsigConfigurations.getStringList('confluence_relay_enabled_packages', []);
			resolvedPackages.set(callerPackage, packages.includes(callerPackage));
		} else {
			resolvedPackages.set(callerPackage, false);
		}
	}

	return resolvedPackages.get(callerPackage)!;
}
